<template>
    <div class="cp2-container">
        <div class="lookup-auth" tabindex="-1">
            <h4 class="lookup-auth__title " v-text="$ml.get('otpTitle')" tabindex="0" />
            <OneTimePasswordC2P
                :card-brands="availableCardBrands"
                :masked-identity-value="maskedValidationChannel"
                :supported-validation-channels="supportedValidationChannels"
                :is-successful="isSuccessful"
                :disable-elements="disableElements"
                :remember-me="rememberMe"
                :error="otpValidationErrorReason"
                :otp-resend-loading="otpResendLoading"
                :network-name="networkName"
                :is-mobile="renderMobile()"
                @otp-changed="otpChanged"
                @continue="continueOtpValidation"
                @remember-me="setRememberMeAgreement"
                @resend-otp="resendOtp"
                @not-you-requested="handleNotYouRequested"
            />
        </div>
        <ButtonsNextPreviousV2
            :disable-button-next="!isSuccessful"
            :loading="loading"
            @click-next="goToNextStep"
            @click-previous="goToPreviousStep"
        />
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import OneTimePasswordC2P from '@/components/ClickToPay/OneTimePasswordC2P';
import loader from '@/helpers/loader';
import ButtonsNextPreviousV2 from '../../../components/template/ButtonsNextPreviousV2.vue';
import { logEvent } from '@/helpers/cieloLogger';
import { isMobile } from '@/helpers/isMobile';

export default {
    components: {
        OneTimePasswordC2P,
        ButtonsNextPreviousV2
    },

    created() {
        loader.multiLanguage = this.$ml;
    },

    mounted() {
        this.$store.commit('clickToPayPayment/clearOtpStates');
    },

    data() {
        return {
            loading: false,
            otpResendLoading: false,
        };
    },

    computed: {
        networkName() {
            if (!this.$store.state.clickToPayPayment.networkId) {
                return 'Mastercard';
            }
            const networkName = this.$store.state.clickToPayPayment.networkId;
            return networkName[0].toUpperCase() + networkName.substring(1);
        },

        maskedValidationChannel() {
            return this.$store.state.clickToPayPayment.maskedValidationChannel;
        },

        supportedValidationChannels() {
            return this.$store.state.clickToPayPayment.supportedValidationChannels;
        },

        isSuccessful() {
            return this.$store.state.clickToPayPayment.otpValidation.isSuccessful;
        },

        disableElements() {
            return this.$store.state.clickToPayPayment.otpValidation.disableElements;
        },

        otpValidationErrorReason() {
            return this.$store.state.clickToPayPayment.otpValidation.errorReason;
        },

        rememberMe: {
            get: self => self.$store.state.clickToPayPayment.rememberMeAgreement,
            set(value) { this.$store.state.clickToPayPayment.rememberMeAgreement = value; }
        },

        availableCardBrands() {
            if (this.$store.state.clickToPayPayment.availableCardBrands) {
                return this.$store.state.clickToPayPayment.availableCardBrands;
            }
            return [];
        },

        consumerPresent() {
            return this.$store.state.clickToPayPayment.consumerPresent;
        },

        hasCards() {
            const cards = this.$store.state.clickToPayPayment.cards;
            return cards !== null && cards.length > 0;
        }
    },

    methods: {
        otpChanged(otp) {
            this.$store.state.clickToPayPayment.otpValidation.code = otp;
        },

        async continueOtpValidation() {
            this.loading = true;
            await this.$store.dispatch('clickToPayPayment/validateOtp');
            this.loading = false;
            const error = this.$store.state.clickToPayPayment.otpValidation.error;
            if (error === 'otpRetriesExceededError' || error === 'otpInaccessibleError') {
                this.showRetriesError();
            };
        },

        showRetriesError() {
            Swal.fire({
                type: 'error',
                title: this.$ml.get('warning'),
                text: this.$ml.get('otpRetriesExceededError'),
                confirmButtonText: this.$ml.get('retry'),
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(() => {
                this.$store.dispatch('pipelineV2/pushTo', 'ChangePaymentType');
                this.$store.commit('clickToPayPayment/clearOtpStates');
                this.$store.state.clickToPayPayment.consumerPresent = false;
                this.$store.state.clickToPayPayment.consumer.email = '';
            });
        },

        goToPreviousStep() {
            this.$store.dispatch('pipelineV2/pushTo', 'UserValidationC2P');

            this.$store.state.clickToPayPayment.consumerPresent = false;
            this.$store.state.clickToPayPayment.otpValidation.error = '';
            this.$store.state.clickToPayPayment.consumer.email = '';
        },

        goToNextStep() {
            logEvent({
                category: 'click_to_pay',
                action: 'autenticacao_c2p',
                label: 'Usuário realiza a autenticação OTP em caso de navegador não reconhecido - preenche o codigo e clica em continuar.'
            });
            
            if (this.hasCards) {
                this.$store.dispatch('pipelineV2/pushTo', 'CardListC2P');
            } else if (this.consumerPresent) {
                this.$store.dispatch('pipelineV2/pushTo', 'UnifiedCardPaymentC2P');
            }
        },

        setRememberMeAgreement(value) {
            this.rememberMe = value;
        },

        handleNotYouRequested() {
            this.$store.dispatch('pipelineV2/pushTo', 'UserValidationC2P');
            
            this.$store.state.clickToPayPayment.consumerPresent = false;
            this.$store.state.clickToPayPayment.otpValidation.error = '';
            this.$store.state.clickToPayPayment.consumer.email = '';
        },

        async resendOtp(value) {
            this.otpResendLoading = true;
            await this.$store.dispatch('clickToPayPayment/initiateValidation', value);
            this.otpResendLoading = false;
        },

        renderMobile() {
            return isMobile();
        },
    },
};
</script>

<style lang="scss" scoped>
    .lookup-auth {
        margin-bottom: 32px;

        &__title {
            display: block;
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 8px;
            color: #2F363E;
        }
    }
</style>
